import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';

const DefaultCheckbox = withStyles({
    root: {
        color: '#585858',
        '&$checked': {
            color: '#3DB5E6',
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

export default DefaultCheckbox;
